import { FILTERBYCATEGORY, FILTERBYSEARCH } from "./actionTypes";

export const filterBySearch = (searchText) => {
  return {
    type: FILTERBYSEARCH,
    payload: searchText,
  };
};
export const filterByCategory = (categoryText) => {
  return {
    type: FILTERBYCATEGORY,
    payload: categoryText,
  };
};
